// Field-visibility config for the AddOffice form. The form renders only
// the fields where the entry is true for the location's businessType.
// Estate is the legacy default — any location without a businessType
// (null/undefined/'other'/'tourism') falls back to the estate set.

export type OfficeBusinessType = 'estate' | 'mortgage';

export type OfficeFieldKey =
  | 'officeId'
  | 'zooplaBranchId'
  | 'location'
  | 'type'
  | 'wildCard'
  | 'crmExit'
  | 'branchEmail'
  | 'readEmail'
  | 'robotEmail'
  | 'mortgageEmail'
  | 'valuationEmail'
  | 'phone'
  | 'supplierNumber'
  | 'postalCodes'
  | 'origin'
  | 'source'
  | 'introducerName'
  | 'introducerId'
  | 'introducerBranchName'
  | 'introducerBranchId'
  | 'appointmentNotificationEmail'
  | 'evergladesApiKey';

type VisibilityMap = Record<OfficeBusinessType, Record<OfficeFieldKey, boolean>>;

export const OFFICE_FIELD_VISIBILITY: VisibilityMap = {
  estate: {
    officeId: true,
    zooplaBranchId: true,
    location: true,
    type: true,
    wildCard: true,
    crmExit: true,
    branchEmail: true,
    readEmail: true,
    robotEmail: true,
    mortgageEmail: true,
    valuationEmail: true,
    phone: true,
    supplierNumber: true,
    postalCodes: true,
    origin: false,
    source: false,
    introducerName: false,
    introducerId: false,
    introducerBranchName: false,
    introducerBranchId: false,
    appointmentNotificationEmail: false,
    evergladesApiKey: false
  },
  mortgage: {
    officeId: false,
    zooplaBranchId: false,
    location: false,
    type: true,
    wildCard: false,
    crmExit: true,
    branchEmail: true,
    readEmail: true,
    robotEmail: true,
    mortgageEmail: false,
    valuationEmail: false,
    phone: true,
    supplierNumber: false,
    postalCodes: false,
    origin: true,
    source: true,
    introducerName: true,
    introducerId: true,
    introducerBranchName: true,
    introducerBranchId: true,
    appointmentNotificationEmail: true,
    evergladesApiKey: false
  }
};

export const resolveBusinessType = (raw?: string | null): OfficeBusinessType =>
  raw === 'mortgage' ? 'mortgage' : 'estate';

// evergladesApiKey is gated by the location's CRM integration, not its businessType:
// the key is per source (one per office row) and only means anything on Everglades.
export const isFieldVisible = (
  businessType: OfficeBusinessType,
  field: OfficeFieldKey,
  integration?: string | null
): boolean =>
  field === 'evergladesApiKey' ? integration === 'everglades' : OFFICE_FIELD_VISIBILITY[businessType][field];
